import Forms from "../js/form";
import {CampaignMonitor} from "../js/createsend";
import "magnific-popup";

class Magnific {
    image = { type: 'image' }
    gallery = {
        delegate: 'a',
		type: 'image',
		tLoading: 'Loading image #%curr%...',
		mainClass: 'mfp-no-margins mfp-with-zoom',
		gallery: {
			enabled: true,
			navigateByImgClick: true,
			preload: [0,1] // Will preload 0 - before current, and 1 after the current image
		},
		image: {
			tError: '<a href="%url%">The image #%curr%</a> could not be loaded.',
            verticalFit: true,
            titleSrc: function(item) {
                return `${item.el.attr('title')}`;
            }
        },
        zoom: {
            enabled: true,
            duration: 300 // don't foget to change the duration also in CSS
        }
    }

    inline = {
        type: 'inline',
        fixedContentPos: true,
        fixedBgPos: true,
        overflowY: 'auto',
        closeBtnInside: true,
        preloader: false,
        midClick: true,
        removalDelay: 300,
        mainClass: 'my-mfp-slide-bottom'
    }

    iframe = {
        disableOn: 700,
        type: 'iframe',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false
    }

    form = {
        type: 'inline',
        preloader: false,
        focus: '#name',
        modal: true,
        disableOn: 700,

        // When elemened is focused, some mobile browsers in some cases zoom in
        // It looks not nice, so we disable it:
        callbacks: {
            beforeOpen: function () {
                if ($(window).width() < 700) {
                    this.st.focus = false;
                } else {
                    this.st.focus = '#name';
                }
            }
        }
    }

    formAjax = {
        type: 'ajax',
        alignTop: true,
        overflowY: 'scroll',
        modal: true,
        disableOn: 700,
        callbacks: {
            ajaxContentAdded: function () {

                let forms = this.content[0].getElementsByClassName('js-form-validate');
                if(forms.length) {

                    new Promise((resolve) => {
                        import(/* webpackChunkName: "forms" */ '../js/form')
                        .then((Forms) => {
                            let form =  new Forms.default(forms, {popupInstance: this});
                            resolve(form.submitButton())
                            resolve(form.validate())
                            resolve(form.bindEvents())
                        })
                    })

                   
                    
                }

                (new CampaignMonitor($(this.content).find('[data-form-createsend]'))).init();
            }
        }
    }

    ajax = {
        type: 'ajax',
        alignTop: true,
        overflowY: 'scroll'
    }

    popups = null

    constructor($selector) {
        this.popups = $selector
    }

    initialize () {
        for(var i = 0; i < this.popups.length; i++)
        {
            let popup = this.popups.item(i);
            let type  = popup.dataset.mfpType;

            if(type) {
                console.log('type', type);
                $(popup).magnificPopup(this[type]);
            }
        }
        $(document).on('click', '[data-mfp-type-dismiss]', function (e) {
            e.preventDefault();
            $.magnificPopup.close();
        });
    }

}

export default Magnific;
